var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "knob" }, [
    _c("svg", { staticClass: "knob-svg", attrs: { viewBox: "0 0 100 100" } }, [
      _c("circle", {
        attrs: {
          cx: "50",
          cy: "50",
          r: "45",
          stroke: "#e0e0e0",
          "stroke-width": "10",
          fill: "none"
        }
      }),
      _vm._v(" "),
      _c("circle", {
        style: {
          transition: "stroke-dashoffset 0.5s ease",
          transform: "rotate(-90deg)",
          transformOrigin: "50% 50%"
        },
        attrs: {
          cx: "50",
          cy: "50",
          r: "45",
          stroke: "#4caf50",
          "stroke-width": "10",
          fill: "none",
          "stroke-dasharray": "283",
          "stroke-dashoffset": _vm.offset
        }
      })
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "progress-text" }, [
      _vm._v(_vm._s(_vm.currentStep) + "/" + _vm._s(_vm.totalSteps))
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9f6fe34a", { render: render, staticRenderFns: staticRenderFns })
  }
}